import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetFormsContractService} from './get-forms-contract.service';
import {GetConfigContractService} from './get-config-contract.service';
import {select, Store} from '@ngrx/store';
import * as fromContracts from '../reducers';
import {Observable} from 'rxjs';
import {Rules} from '../models/rules';
import {map, skipWhile} from 'rxjs/operators';
import {Contract, ContractForm, MiscellaneousContractForm} from '../models/contract';
import {ContractMapperService} from './contract-mapper.service';
import {GetFormsService} from '../../shared/services/get-forms.service';
import {GetConfigSharedService} from '../../shared/services/get-config-shared.service';
import * as moment from 'moment';
import {ContractLanguageTextComponent} from '../components/contract-language-text/contract-language-text.component';
import * as fromSites from '../../site/reducers';
import {Site} from '../../shared/models/site';
import {MiscellaneousSiteForm} from '../../site/models/site-form';

@Injectable({
  providedIn: 'root'
})
export class ContractDataService {
  constructor(private getFormsService: GetFormsContractService,
              private getConfigService: GetConfigContractService,
              private storeContract: Store<fromContracts.AppState>,
              private getFormsSharedService: GetFormsService,
              private getConfigSharedService: GetConfigSharedService,
              private contractMapperService: ContractMapperService) {
  }

  getContractsListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Contracts',
          contentTab: 'datatableContractList',
          dataConfig: {
            form: this.getFormsService.getFilterContract(),
            groupConfigs: this.getConfigService.getConfigs(),
            header :  {
              icon: 'fal fa-file-signature',
              text: 'GENERIC_CONTRACTS',
              rightSideButton : {
                buttonTitle : 'CONTRACT_NEW_TITLE',
                buttonIcon: 'fal fa-file-signature',
                buttonTitleExtra : 'CONTRACT_LINK_MODAL_LINK_EXISTING_CONTRACT',
                buttonIconExtra: 'fad fa-link',
                actionTypeExtra: 'ModalLink',
                action: 'link',
                href : ['/', 'contracts', 'add'],
              },
            } ,
            content: [
              {
                name: 'GENERIC_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'detail',
              //  fragment: contract
              },
              {
                name: 'CONTRACT_PURCHASE_ORDER',
                prop: 'po',
                sortable: true,
                type: 'text',
              },
              {
                name: 'GENERIC_SERVICES_LABEL',
                prop: 'service',
                sortable: true,
                type: 'service'
              },
              {
                name: 'GENERIC_START_DATE',
                prop: 'startDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_END_DATE',
                prop: 'endDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PRICE',
                prop: 'price',
                sortable: true,
                type: 'concatenatePrice',
                concatenate: ['price', 'currencyIsoCode'],
                emptyData: 'CONTRACT_LIST_PRICE_EMPTY_DATA',
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'CONTRACT_SUBSCRIPTION_COUNTS',
                prop: 'subscriptionTotalCount',
                type: 'concatenate',
                concatenate: ['Exploit: ' , 'subscriptionExploitCount', ' Total: ' , 'subscriptionTotalCount'],
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'linkModal',
                  class: 'fad fa-lg fa-link',
                  tooltip: 'CONTRACT_LINK_MODAL_LINK_SUBSCRIPTIONS',
                }
              },
              {
                name: '',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'duplicateModal',
                  class: 'far fa-lg fa-copy',
                  tooltip: 'CONTRACT_DUPLICATION_MODAL_TITLE',
                }
              }
            ]
          },
        }
      ]
    }
  }
  getInvoicesListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: {
            form: this.getFormsSharedService.getFilterCompanyInvoices(),
            groupConfigs: this.getConfigSharedService.getInvoicesContractFilter(),
            header :  {
              icon: 'fal fa-wallet',
              text: 'GENERIC_INVOICES'
            } ,
            content: [
              {
                name: 'GENERIC_CODE',
                prop: 'code',
                sortable: true,
                type: 'text',
              },
              {
                name: 'INVOICES_LOGISTIC_JOURNAL',
                prop: 'logisticJournal',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_COMPANY_NAME',
                prop: 'companyName',
                sortable: true,
                type: 'routerLink',
                path: 'companyName',
              },
              {
                name: 'GENERIC_COVERS_START',
                prop: 'coverStart',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_COVERS_END',
                prop: 'coverEnd',
                sortable: true,
                type: 'date'
              },
              {
                name: 'CONTRACT_PURCHASE_ORDER',
                prop: 'purchaseOrder',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_INVOICE_NUMBER',
                prop: 'number',
                sortable: true,
                type: 'detailRouterLink',
                path: 'invoicesDetail',
              },
              {
                name: 'GENERIC_SPLIT',
                prop: 'split',
                sortable: true,
                type: 'select',
                data: [
                  { id: 1, name: 'PO' },
                  { id: 2, name: 'Site' },
                  { id: 3, name: 'Country' },
                  { id: 4, name: 'Contract' },
                  { id: 5, name: 'Client' },
                  { id: 6, name: 'Company' },
                ]
              },
              {
                name: '' ,
                prop: 'isAdjustment',
                sortable: false,
                type: 'icon',
                icon: {
                  classFn: (row): string => (row.isAdjustment ? 'far fa-file-invoice-dollar' : ''),
                  tooltip: 'GENERIC_INVOICE_IS_ADJUSTMENT'
                }
              },
              {
                name: 'GENERIC_COUNTRY',
                prop: 'countryCode',
                sortable: true,
                type: 'country',
              },
              {
                name: 'GENERIC_OFFICE',
                prop: 'officeID',
                sortable: true,
                array: [  { id: 1, name: 'OFFICE_BE' },
                          { id: 2, name: 'OFFICE_FR' },
                          { id: 3, name: 'OFFICE_ES' },
                          { id: 4, name: 'OFFICE_DE' },
                          { id: 5, name: 'OFFICE_CN' },
                          { id: 6, name: 'OFFICE_IT' },
                          { id: 7, name: 'OFFICE_NL' },
                          { id: 8, name: 'OFFICE_UK' },
                          { id: 9, name: 'OFFICE_HK' }],
                type: 'array'
              },

              // {
              //   name: 'GENERIC_CODE',
              //   prop: 'logisticsIdentifier',
              //   sortable: true,
              //   type: 'test',
              // },

              // {
              //   name: 'GENERIC_CONTRACT_NAME',
              //   prop: 'contractName',
              //   sortable: true,
              //   type: 'routerLink',
              //   path: 'contractName',
              // },
              // {
              //   name: 'INVOICES_LINE_CODE',
              //   prop: 'invoiceLineCode',
              //   sortable: true,
              //   type: 'text'
              // },
              // {
              //   name: 'INVOICES_LINE_NAME',
              //   prop: 'invoiceLineName',
              //   sortable: true,
              //   type: 'text'
              // },
              // {
              //   name: '#',
              //   prop: 'count',
              //   sortable: true,
              //   type: 'tooltipText',
              //   tooltip: 'Subscription',
              // },
              // {
              //   name: 'GENERIC_UNIT_PRICE',
              //   prop: 'unitPrice',
              //   sortable: true,
              //   type: 'text'
              // },
              {
                name: 'GENERIC_TOTAL',
                prop: 'total',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_CREATED',
                prop: 'created',
                sortable: true,
                type: 'date',
              }
            ]
          },
        }
      ]
    }
  }
  getSubListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: {
            form: this.getFormsService.getFilterSubscription(),
            groupConfigs: this.getConfigService.getSubscriptionFilter(),
            header :  {
              icon: 'fal fa-building',
              text: 'GENERIC_SUBSCRIPTION_NAME',
            } ,
            content: [
              {
                name: 'checkBox',
                prop: 'checkBox',
                sortable: false,
                type: 'checkBox'
              },
              {
                name: '',
                prop: 'serviceId',
                sortable: true,
                type: 'service'
              },
              {
                name: 'GENERIC_SUBSCRIPTION_NAME',
                prop: 'subscriptionName',
                sortable: true,
                type: 'detailRouterLink',
                path: 'SubName',
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'status',
                sortable: true,
                type: 'iconListSwitch',
                data: [
                  {tooltip: 'SUBSCRIPTIONS_STATUS_EXPLOIT' , icon: 'fa fa-fw fa-flag text-success', value: 3 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_DEMO' , icon: 'fa fa-fw fa-flask text-info', value: 2 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_OFF' , icon: 'fa fa-fw fa-power-off text-danger', value: 1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_TO_OFF' , icon: 'fa fa-fw fa-flag-checkered text-warning', value: 0 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_STOP' , icon: 'fa fa-fw fa-stop text-danger', value: -1 },
                  {tooltip: 'SUBSCRIPTIONS_STATUS_BANKRUPTCY' , icon: 'fas fa-university text-danger', value: -2 }
                ]
              },
              {
                name: 'GENERIC_CLIENT',
                prop: 'clientName',
                sortable: true,
                type: 'routerLink',
                path: 'clientName',
              },
              {
                name: 'GENERIC_START_DATE',
                prop: 'startBilling',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_END_DATE',
                prop: 'endBilling',
                sortable: true,
                type: 'date'
              },
              {
                name: 'ORDERS_LIST_DELIVERY_DATE',
                prop: 'deliveryDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_PRICE',
                prop: 'price',
                sortable: true,
                type: 'concatenatePrice',
                concatenate: ['price', 'currencyIsoCode'],
                emptyData: 'CONTRACT_LIST_PRICE_EMPTY_DATA',
              },
              {
                name: 'GENERIC_COMPANY_NAME',
                prop: 'companyName',
                sortable: true,
                type: 'routerLink',
                path: 'companyName',
              },
              {
                name: 'GENERIC_PRODUCT',
                prop: 'productName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_PLAYER_NAME',
                prop: 'playerName',
                sortable: true,
                type: 'externalPortal'
              },
              {
                name: 'GENERIC_LAST_INVOICE_CALCULATION',
                prop: 'lastInvoiceCalculation',
                sortable: true,
                type: 'date'
              },
              {
                name: 'M_MENU_C_CONTEXTUEL',
                prop: '',
                sortable: false,
                type: 'iconModal',
                icon: {
                  modal: 'CloseSiteBillingModal',
                  class: 'fal fa-window-close',
                  tooltip: 'CONTRACT_CLOSE_SITE_BILLING_MODAL_TITLE',
                  disabledFn: (row): boolean => (row.status === 1 && (moment(row.endBilling).year()  < new Date().getFullYear()) ),
                }
              },
            ]
          },
        }
      ]
    }
  }
  getContractsDetailData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Contract',
          contentTab: 'contractEditable',
          dataConfig: {
            form: this.getFormsService.getForm(),
            groupConfigs: this.getConfigService.getConfigs(),
            content: this.mapDataContractToForm(this.storeContract.pipe(select(fromContracts.selectors.getCurrentContract))),
            contentOther: this.mapDataRulesToForm(this.storeContract.pipe(select(fromContracts.selectors.getRules)))
          }
        },
        {
          titleTab: 'Subscription',
          contentTab: 'subscriptionsList',
          dataConfig: this.getSubListData().dataTabs[0].dataConfig,

        },
        {
          titleTab: 'Invoices',
          contentTab: 'invoicesList',
          dataConfig: this.getInvoicesListData().dataTabs[0].dataConfig,

        },
        {
          titleTab: 'Translation',
          contentTab: 'contractLanguageText',
          dataConfig: {
            form: this.getFormsSharedService.getLanguageTextsContract(),
            groupConfigs: this.getConfigSharedService.getLanguageTextsConfigs(),
          }

        },
        {
          titleTab: 'Miscellaneous',
          contentTab: 'miscellaneousEditable',
          dataConfig: {
            form: this.getFormsService.getMiscellaneous(),
            groupConfigs: this.getConfigService.getMiscellaneousConfigs(),
            content: this.mapDataMiscellaneous(this.storeContract.pipe(select(fromContracts.selectors.getCurrentContract)))
          },
        },

      ]
    }
  }
  mapDataMiscellaneous(data: Observable<Contract>): Observable<MiscellaneousContractForm> {
    return data.pipe(
      skipWhile((s: Contract) => !s),
      map(contract => this.contractMapperService.miscellaneousDbToForm(contract))
    )
  }
  getAddContracts(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Contract',
          contentTab: 'contractEditable',
          dataConfig: {
            form: this.getFormsService.getForm(),
            groupConfigs: this.getConfigService.getConfigs(),
            content: this.mapDataContractToForm(this.storeContract.pipe(select(fromContracts.selectors.getCurrentContract))),
            contentOther: this.mapDataRulesToForm(this.storeContract.pipe(select(fromContracts.selectors.getRules)))
          }
        }
      ]
    }
  }

  mapDataContractToForm(data: Observable<Contract>): Observable<ContractForm> {
    return data.pipe(
      skipWhile((s: Contract) => !s),
      map((c: Contract) => this.contractMapperService.contractDbToForm(c))
    )
  }
  mapDataRulesToForm(data: Observable <Rules[]>): Observable<Rules[]> {
    return data.pipe(
      skipWhile((c: Rules[]) => !c),
      map(rules => rules)
    )
  }

}


